export default "__VITE_ASSET__B$fD7A33__"